// This copies Auth0's (app#7529 @ 3c8d887b9a).

/** `lines` as the lines of an HCL comment. Each line after the first starts
 * with `indent`, for a comment inside a block. */
export const toHclComment = (lines: readonly string[], indent = "") =>
  lines.map((line) => `# ${line}`).join(`\n${indent}`);
